/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* DetachExcludedAddressesRequest is the detach counterpart of AttachExcludedAddressesRequest (same required attachment_type semantics).
*/
export class V1DetachExcludedAddressesRequest {
    'orgId'?: string;
    'fileId'?: string;
    'pixelId'?: string;
    'subscriptionId'?: string;
    /**
    * \"subscription\" or \"pixel\" — required; selects the detach level explicitly.
    */
    'attachmentType'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileId",
            "baseName": "file_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "pixelId",
            "baseName": "pixel_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscriptionId",
            "baseName": "subscription_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "attachmentType",
            "baseName": "attachment_type",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1DetachExcludedAddressesRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

